import { useState, type FormEvent } from 'react';

const FORM_SUBMIT_ADDR = 'https://readdy.ai/api/form/daim3njoh653ivfvog1g';

type Status = 'idle' | 'loading' | 'success' | 'error';

export default function SubscribeForm() {
  const [status, setStatus] = useState<Status>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);

    const guard = String(data.get('contact_alt') || '').trim();
    if (guard) {
      setStatus('success');
      setFormError('');
      form.reset();
      return;
    }

    data.delete('contact_alt');

    setStatus('loading');
    setFormError('');

    try {
      const response = await fetch(FORM_SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(data as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';
      const isSpam = /spam/i.test(serverMsg) || /spam/i.test(parsed?.code || '');
      const codeOk = parsed?.code === 'OK';

      if (response.ok && codeOk && !isSpam) {
        setStatus('success');
        setFormError('');
        form.reset();
      } else {
        setStatus('error');
        setFormError(serverMsg || '提交失败，请稍后重试。');
      }
    } catch (err) {
      setStatus('error');
      setFormError(err instanceof Error ? err.message : '网络异常，请稍后重试。');
    }
  };

  return (
    <form
      id="subscribe"
      data-readdy-form
      onSubmit={handleSubmit}
      className="relative w-full scroll-mt-24"
    >
      <div className="flex flex-col gap-3 sm:flex-row">
        <div className="relative flex-1">
          <i
            className="ri-mail-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-base text-foreground-400"
            aria-hidden="true"
          ></i>
          <input
            type="email"
            name="email"
            required
            placeholder="输入邮箱，抢先收到第一手消息"
            className="w-full rounded-md border border-background-300 bg-background-50 py-3 pl-10 pr-3 text-sm text-foreground-950 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
          />
        </div>
        <input
          type="text"
          name="contact_alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
          className="subscribe-guard-field"
        />
        <button
          type="submit"
          disabled={status === 'loading'}
          className="inline-flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 dark:text-foreground-950 whitespace-nowrap transition-colors hover:bg-primary-600 disabled:opacity-60"
        >
          <i className={status === 'loading' ? 'ri-loader-4-line animate-spin' : 'ri-send-plane-fill'} aria-hidden="true"></i>
          {status === 'loading' ? '提交中…' : '立即订阅'}
        </button>
      </div>

      {status === 'success' && (
        <p className="mt-3 flex items-center gap-1.5 text-sm text-accent-700">
          <i className="ri-checkbox-circle-line" aria-hidden="true"></i>
          订阅成功，下一条爆料我们会第一时间发给你。
        </p>
      )}
      {status === 'error' && (
        <p className="mt-3 flex items-center gap-1.5 text-sm text-primary-600">
          <i className="ri-error-warning-line" aria-hidden="true"></i>
          {formError}
        </p>
      )}
      <p className="mt-3 text-xs text-foreground-500">
        我们只在有重要更新时发送邮件，不会频繁打扰，也不会共享你的邮箱。
      </p>
    </form>
  );
}